var handleDetail = window.location.pathname.split("/");

handleDetail = handleDetail[handleDetail.length - 1];

var getShopId = localStorage.getItem("shopId");

// if (handleDetail || localStorage.getItem("detailId")) {
//   getSize();
//   getModel();
// }

if(window.location.pathname?.includes('/products/')){
  getSize();
  getModel();
}

function getSize() {
  // var urlSize = 'https://user-api.heychic.net/web/product/sizeData';
  var urlSize = `${heychic_api}/web/product/sizeData`;

  var paramsSize = {
  };

  // 根据条件添加 product_handle 或 product_number
  if (!$("body").hasClass("edit-cart-show")) {
    paramsSize.product_handle = handleDetail;
  } else {
    paramsSize.product_number = localStorage.getItem("detailId");
  }

  getProductPreOrder(localStorage.getItem("detailId"))

  // 使用 URLSearchParams 对象来处理参数
  var urlParams = new URLSearchParams(paramsSize);

  // 添加查询参数到 URL 中
  urlSize = `${urlSize}?${urlParams.toString()}`;

  fetch(urlSize,
    {headers: {
      "Content-Type": "application/json",
      "X-Shop-Id": getShopId || "59363262637",
    }}
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // data.data.size_data不为空数组时
      if (data.code == 200) {
        if (data.data) {
          var sizeDataList = data.data.size_data;
          var getSizeTable = data.data.size_table || [];
          var typeInfo = {
            fitType: data.data.product_info.product_attr_fit_type - 1,
            thickness: data.data.product_info.product_attr_thickness - 1,
            stretch: data.data.product_info.product_attr_stretch - 1,
          };
          var measureImg = data.data.product_info.size_measure_image || "";

          // 根据不同的类名做判断显示
          if ($("body").hasClass("edit-cart-show")) {
            localStorage.setItem(
              "sizeDataListDetail",
              JSON.stringify(sizeDataList)
            );
            localSizeListDetail =
              sizeDataList &&
              sizeDataList.length &&
              sizeDataList.filter(
                (item) => item.variant_id == localStorage.getItem("itemId")
              );
          } else {
            localStorage.setItem("sizeDataList", JSON.stringify(sizeDataList));
          }
          localStorage.setItem("getSizeTable", JSON.stringify(getSizeTable));
          localStorage.setItem("typeInfo", JSON.stringify(typeInfo));
          localStorage.setItem("measureImg", measureImg);
        } else {
          localStorage.removeItem("getSizeTable");// 清除本地表单数据
        }
        
      }
    })
    .catch((error) => {
      console.error("Fetch error:", error);
      // 处理错误
    });

    if ($("body").hasClass("edit-cart-show")) {
      saveVariantId(true, localStorage.getItem("itemId"), localStorage.getItem("detailId"))
    }
}

function getModel() {
  // var urlSizeModel = 'https://user-api.heychic.net/web/product/modelDetails';
  var urlSizeModel = `${heychic_api}/web/product/modelDetails`;
  var paramsSizeModel = {
    shop_id: getShopId || "59363262637",
  };

  // 根据条件添加 product_handle 或 product_number
  if (!$("body").hasClass("edit-cart-show")) {
    paramsSizeModel.product_handle = handleDetail;
  } else {
    paramsSizeModel.product_number = localStorage.getItem("detailId");
  }

  // 使用 URLSearchParams 对象来处理参数
  var urlParamsModel = new URLSearchParams(paramsSizeModel);

  // 添加查询参数到 URL 中
  urlSizeModel = `${urlSizeModel}?${urlParamsModel.toString()}`;

  fetch(urlSizeModel)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      if (data.code == 200) {
        if (data.data.length) {
          const $container = $("#model-container");
          // 模特
          $("#model-container").css("display", "block");
          $container.empty();

          const modelInfos = data.data || [];
          localStorage.setItem("modelInfos", JSON.stringify(modelInfos));

          if (modelInfos.length > 0) {
            data.data.forEach((item) => {
              const modelBlock = `
                    <div class="model-text">
                        ${
                          item.model_image
                            ? `<img src="${item.model_image}" alt="model-image" class="model-image"></img>`
                            : ""
                        }
                        <div>
                          <div class="imogen-name">${item.model_name || ''}</div>
                          <div class="spanWidth first-name-model">
                            <span class="model-name">Size <span class="model-wears">${item.now_wearing_size}</span></span>
                            <span class="model-wears model-wears-new">${item.now_wearing}</span>
                            <span class="model-wears">${item.now_wearing_us}</span>  
                          </div>
                          ${modelGetText('Height',item.model_height)}
                          ${modelGetText('Bust',item.model_bust)}
                          ${modelGetText('Hips',item.model_hips)}
                          ${modelGetText('Waist',item.model_waist)}
                        </div>
                    </div>
                `;

              $container.append(modelBlock);
            });
          }
        } else {
          $("#model-container").css("display", "none");
          $(".modelInfo").css("display", "none");
          $('.modelLine').css('display','none');
        }
      }
    })
    .catch((error) => {
      // 处理错误
      console.error("Fetch error:", error);
    });
}

function modelGetText(name,type) { 
  return `
    <div class="spanWidth">
      <span class="model-name">${name} </span>
      <span class="model-height">${
        type
      }cm</span>
      <span class="model-inch">${
        Math.round((type / 2.54))
      }in</span>
    </div>
  `
}
